import React, { Component } from "react";

const OilsIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0971 6.92535C13.5093 5.78844 12.349 5.08215 11.0691 5.08215H8.3791V3.9084H9.55238V2.73652H8.3791V2.14969C8.3791 0.964375 7.41477 0 6.22945 0C5.04414 0 4.07977 0.964375 4.07977 2.14969V2.73652H2.90648V3.9084H4.07977V8.59875C2.97766 9.00562 1.99402 9.72902 1.27672 10.6679C0.441485 11.7609 0 13.0676 0 14.4466C0 16.7377 1.25313 18.8387 3.27035 19.9294L3.40078 20H9.05813L9.18855 19.9294C11.2058 18.8386 12.4589 16.7377 12.4589 14.4466C12.4589 13.8656 12.3802 13.2976 12.2271 12.7529L13.8505 10.4616C14.5905 9.4173 14.685 8.0623 14.0971 6.92535ZM5.2516 2.14969C5.2516 1.61051 5.69023 1.17188 6.22941 1.17188C6.76859 1.17188 7.20723 1.61051 7.20723 2.14969V2.73652H5.2516V2.14969ZM2.20785 11.3794C2.86441 10.5201 3.79484 9.88313 4.82773 9.5859L5.25164 9.46391V3.90844H7.20727V9.46391L7.63117 9.5859C8.66406 9.88313 9.59449 10.5201 10.2511 11.3794C10.8824 12.2057 11.2361 13.1827 11.2816 14.2176C10.8322 14.161 10.5403 14.04 10.2165 13.9055C9.72504 13.7014 9.16801 13.4701 8.11059 13.4701C7.05316 13.4701 6.49613 13.7014 6.00465 13.9055C5.55785 14.0911 5.17195 14.2513 4.34816 14.2513C3.52445 14.2513 3.13859 14.0911 2.6918 13.9055C2.31699 13.7498 1.90359 13.5784 1.25945 13.5058C1.40324 12.7363 1.72344 12.0134 2.20785 11.3794ZM8.75727 18.8281H3.7016C2.20371 17.9625 1.25531 16.3982 1.17766 14.6757C1.62688 14.7323 1.91859 14.8533 2.2423 14.9878C2.73375 15.1919 3.29074 15.4232 4.34816 15.4232C5.40559 15.4232 5.96262 15.1918 6.4541 14.9877C6.9009 14.8022 7.2868 14.6419 8.11059 14.6419C8.93437 14.6419 9.32023 14.8022 9.76707 14.9877C10.1417 15.1433 10.5549 15.3147 11.1985 15.3874C10.9275 16.8218 10.0457 18.0836 8.75727 18.8281ZM12.8943 9.78418L11.702 11.467C11.5505 11.1902 11.3773 10.9232 11.1822 10.6679C10.4649 9.72906 9.48129 9.00566 8.37914 8.59879V6.25406H11.0692C11.9218 6.25406 12.6646 6.70621 13.0562 7.46359C13.4477 8.22094 13.3872 9.08848 12.8943 9.78418Z"
        fill={fill}
      />
    </svg>
  );
};

OilsIcon.defaultProps = {
  width: 15,
  height: 20,
  fill: "black",
};

export default OilsIcon;
